import queryString from 'query-string';
import { useLocation } from 'react-router-dom';

export function useSearchParams() {
  return queryString.parse(useLocation().search);
}
